'use client'

import { motion } from 'framer-motion'
import { FaArrowDown } from 'react-icons/fa'

export default function HeroSection() {
  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Video com Overlay */}
      <div className="absolute inset-0 z-0">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
        >
          <source src="/assets/images/videovibe.mp4" type="video/mp4" />
        </video>

        {/* Gradiente Overlay para legibilidade e estilo */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/60 to-black"></div>
        
        {/* Efeito de granulação (Noise) para textura */}
        <div className="absolute inset-0 opacity-[0.03] bg-[url('https://grainy-gradients.vercel.app/noise.svg')]"></div>
      </div>

      {/* Conteúdo */}
      <div className="container mx-auto px-4 relative z-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <h1 className="text-4xl sm:text-5xl md:text-7xl lg:text-8xl font-black leading-tight mb-6 tracking-tight">
            <span className="block text-white drop-shadow-2xl">
              VIVA O
            </span>
            <span className="bg-gradient-to-r from-[#ffa300] via-yellow-400 to-[#ffa300] bg-clip-text text-transparent drop-shadow-lg animate-pulse">
              INESQUECÍVEL
            </span>
          </h1>
        </motion.div>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
          className="text-lg sm:text-xl md:text-2xl text-zinc-300 mb-10 max-w-2xl mx-auto font-light leading-relaxed"
        >
          A plataforma definitiva para suas melhores experiências universitárias. 
          Festas, shows e momentos que ficam para sempre.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="flex flex-col sm:flex-row gap-4 justify-center items-center"
        >
          <a
            href="#eventos"
            className="group relative px-6 py-4 min-h-[48px] flex items-center justify-center bg-[#ffa300] text-black font-bold text-lg rounded-full shadow-[0_0_20px_rgba(255,163,0,0.3)] hover:shadow-[0_0_30px_rgba(255,163,0,0.5)] transition-all duration-300 hover:scale-105 overflow-hidden"
          >
            <span className="relative z-10 flex items-center gap-2">
              GARANTIR INGRESSO
            </span>
            <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300"></div>
          </a>
          
          <a
            href="#contato"
            className="px-6 py-4 min-h-[48px] flex items-center justify-center border border-zinc-700 text-white font-semibold text-lg rounded-full hover:bg-white/5 hover:border-white/20 transition-all duration-300 backdrop-blur-sm"
          >
            Saiba Mais
          </a>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1, duration: 1 }}
        className="absolute left-1/2 -translate-x-1/2 text-white/50 flex flex-col items-center gap-2 bottom-[calc(1.5rem+env(safe-area-inset-bottom,0))] sm:bottom-[calc(2.5rem+env(safe-area-inset-bottom,0))]"
      >
        <span className="text-xs uppercase tracking-widest">Scroll</span>
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
        >
          <FaArrowDown />
        </motion.div>
      </motion.div>
    </section>
  )
}

